import logo from './timer.png';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './pages/Layout';
import Home from './pages/Home';
import Blogs from './pages/Blogs';
import Contact from './pages/Contact';
import NoPage from './pages/NoPage';
import Timer from './components/Timer';
import TicTacToe from './tic-tac-toe/TicTacToe';
import './components/Header.css';
import './App.css'
import Clock from './components/Clock';

function App() {
  return (
    <>
      <img className='App-logo' src={logo} width={50} height={50} />
      <Clock />
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<Layout />}>
            <Route path='timer' element={<Timer />} />
            <Route path='contact' element={<Contact />} />
            <Route path='tic-tac-toe' element={<TicTacToe />} />
            <Route path='*' element={<NoPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
